import { lazy } from "react";
import { RouteConfig } from "./types";

// Lazy load page components for better performance
const AppointmentScheduler = lazy(
  () => import("../pages/AppointmentScheduler"),
);
const ClientProfile = lazy(() => import("../pages/Clients/ClientProfile"));
const EditClient = lazy(() => import("../pages/Clients/EditClient"));
const NewClient = lazy(() => import("../pages/Clients/NewClient"));
const PetProfile = lazy(() => import("../pages/Clients/PetProfile"));
const SearchResults = lazy(() => import("../pages/Clients/SearchResults"));
const Clients = lazy(() => import("../pages/Clients/Clients"));
const CreateBookingPage = lazy(
  () => import("../pages/Booking/CreateBookingPage"),
);
const EditBookingPage = lazy(() => import("../pages/Booking/EditBookingPage"));
const SalePage = lazy(() => import("../pages/Booking/SalePage"));
const BudgetPage = lazy(() => import("../pages/Booking/BudgetPage"));
const AddPet = lazy(() => import("../pages/Clients/AddPet"));
const EditPet = lazy(() => import("../pages/Clients/EditPet"));

export const routes: RouteConfig[] = [
  {
    path: "/",
    element: AppointmentScheduler,
    title: "Dashboard",
    icon: "dashboard",
  },
  {
    path: "/atendimento",
    element: CreateBookingPage,
    title: "Criar Agendamento",
  },
  {
    path: "/atendimento/:appointmentId",
    element: EditBookingPage,
    title: "Editar Agendamento",
  },
  {
    path: "/venda/:saleId?",
    element: SalePage,
    title: "Venda",
  },
  {
    path: "/orcamento/:budgetId?",
    element: BudgetPage,
    title: "Orcamento",
  },
  {
    path: "/clientes",
    element: Clients,
    title: "Clientes",
    icon: "clients",
  },
  {
    path: "/clientes/pesquisa",
    element: SearchResults,
    title: "Resultados da Pesquisa",
  },
  {
    path: "/clientes/novo",
    element: NewClient,
    title: "Novo Cliente",
  },
  {
    path: "/clientes/:id",
    element: ClientProfile,
    title: "Perfil do Cliente",
  },
  {
    path: "/clientes/:id/editar",
    element: EditClient,
    title: "Editar Cliente",
  },
  {
    path: "/clientes/:clientId/animal/novo",
    element: AddPet,
    title: "Novo Animal",
  },
  {
    path: "/clientes/:clientId/animal/:petId/editar",
    element: EditPet,
    title: "Editar Animal",
  },
  {
    path: "/clientes/:clientId/animal/:petId",
    element: PetProfile,
    title: "Perfil do Animal",
  },
];

export default routes;
